import { LocationWizardData } from '../../../domain/LocationWizardData'
import { mutateAreaPoint } from '~/utility/geo/mutate-area'
import { SearchWizardFilters } from '../../domain/SearchWizardFilters'

export function locationDataFilters({
  filters,
  data,
  defaults,
}: {
  data: LocationWizardData
  filters: SearchWizardFilters
  defaults: {
    defaultWithinRange: number
  }
}): SearchWizardFilters {
  const hierarchyPath = locationDataToHierarchyPath(data)
  const point = locationDataToPoint(data)
  return {
    ...filters,
    area: mutateAreaPoint(filters.area, point, {
      defaultWithinMiles: defaults.defaultWithinRange,
    }),
    hierarchyPath,
  }
}

function locationDataToHierarchyPath(
  payload: LocationWizardData,
): string | undefined {
  const hierarchyPathFromHierarchyData =
    'path' in payload ? payload.path : undefined
  const hierarchyPathFromCampsiteData =
    'hierarchyPath' in payload ? payload.hierarchyPath : undefined
  return hierarchyPathFromHierarchyData || hierarchyPathFromCampsiteData
}

function locationDataToPoint(data: LocationWizardData) {
  if (data.dataType === 'custom') {
    return 'point' in data ? data.point : undefined
  }
  return undefined
}
